import { c as _c } from "react/compiler-runtime";
import { Text, ExclamationMarkCircleFillIcon } from "@flat-ui";
import { NumberUtils } from "@stellar/utils";
import { Box, Stack } from "@mui-wrapper";
/** Displays how many of the Scene license seats of a workspace are already assigned */
export function SceneSeatUsage(t0) {
  const $ = _c(21);
  const {
    usage,
    actionComponent
  } = t0;
  const shouldShowWarning = usage.used > usage.max;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center",
      gap: 1,
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: 1
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== shouldShowWarning) {
    t3 = shouldShowWarning && <ExclamationMarkCircleFillIcon sx={{
      color: "warning.main",
      width: "20px",
      height: "20px"
    }} />;
    $[2] = shouldShowWarning;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== usage.used) {
    t4 = NumberUtils.formatNumberWithSpaces(usage.used);
    $[4] = usage.used;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <Text variant="heading20">{t4}</Text>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== usage.max) {
    t6 = NumberUtils.formatNumberWithSpaces(usage.max);
    $[8] = usage.max;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = ` / ${t6} seats`;
  let t8;
  if ($[10] !== t7) {
    t8 = <Text variant="bodyM">{t7}</Text>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Box>{t5}{t8}</Box>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t9) {
    t10 = <Stack direction="row" sx={t2}>{t3}{t9}</Stack>;
    $[15] = t3;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== actionComponent || $[19] !== t10) {
    t11 = <Stack direction="row" sx={t1}>{t10}{actionComponent}</Stack>;
    $[18] = actionComponent;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}